import React, { useContext, useEffect,useState } from 'react';
import { BuilderContext, useDrawer,NodeContext } from 'react-custom-flow-builder';
import { Form, Button, Input ,Radio,Select,Checkbox,Divider} from 'antd';
import "antd/dist/antd.css";
import {setPreferences,setInsertData} from '../../app/slice/flowBuilderSlice';
import { useDispatch, useSelector } from 'react-redux';
import InputLabel from '@mui/material/InputLabel';
import { CaretDownOutlined} from '@ant-design/icons';
import './ConfigPanel.css' 
import { json } from 'stream/consumers';
import ConditionForm from "../ConditionForm/ConditionForm"


const { TextArea } = Input;

const ConfigForm: React.FC = () => {
  const dispatch = useDispatch();
  const { selectedNode: node } = useContext(BuilderContext);
  const insertData=useSelector((state:any)=>state.flowBuilder.insertData);
  const PreferencesObj=useSelector((state:any)=>state.flowBuilder.preferences);
  const [localInsert,setLocalInsert]=useState<any>([])
  const { closeDrawer: cancel, saveDrawer: save } = useDrawer();

  const [form] = Form.useForm();

  const [formData,setFormData]=useState<any>({});

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      const updatedForm = {...formData,...values}
      setFormData(updatedForm);
      save?.(updatedForm);
    } catch (error) {
      const values = form.getFieldsValue();
      const updatedForm = {...formData,...values}
      setFormData(updatedForm);
      save?.(updatedForm, !!error);
    }
  };

const el=node?.configElements;

const checkCatergory=(categoryId:any,item:any)=>{

  //check for default category
  if(categoryId===1000)
  {return true;}

  for (const key in PreferencesObj) {
    if(PreferencesObj[key].Id===categoryId)
    {return true;}
  }
  if((node?.data)  && node?.data[item.name]){
    node.data[item.name]="";
  }
  return false;
}

 const removeCategory=(categoryId:number,LocalPreferencesObj:any)=>{
  if(categoryId){
  for(const key in LocalPreferencesObj){
   if(LocalPreferencesObj[key].category===categoryId){
     const itemId= LocalPreferencesObj[key].Id;
     LocalPreferencesObj[key]="";
     removeCategory(itemId,LocalPreferencesObj);
   }
  }
 }
 return LocalPreferencesObj;
}



  const handleMultiOptionSelection=async (item:any,e:any)=>{
   const propertyId = item.Id;
   const LocalPreferencesObj  = JSON.parse(JSON.stringify(PreferencesObj));
   const oldSelectedId= PreferencesObj[propertyId]?.Id;
   const updatedPreferencesObj =await removeCategory(oldSelectedId,LocalPreferencesObj);
   const selectedOption = item.data.filter((item:any)=>item.value===e)[0];
   const selectedObj={
    Id:selectedOption.Id,
    parentId:selectedOption.parentId,
    category:item.category
   }
   const updatedValidationObj={...updatedPreferencesObj,[propertyId]:selectedObj}
   dispatch(setPreferences(updatedValidationObj));
  }

  const handleShowConditionForm=()=>{
    const updatedForm = {...formData,testCD1:'asdfa'};
    setFormData(updatedForm);
  }
  

  return (
 <>
  <div className='config-section'>
  <Form form={form} className='config-form' >
    <div className='input-div'>
      <label className="floating-label" htmlFor="client-name-input">Name</label>
      <Form.Item name="displayName" initialValue={(node?.data)?node?.data.displayName:node?.name} rules={[{ required: true }]}>
        <Input
          id="client-name-input"
          className='input-field-1'
          required type="text" 
          bordered={false}     
                        
        />
          </Form.Item>
      </div>

      
  { node?.configElements?.map((item:any) => {
    return <>
     {item.type==='divider' && checkCatergory(item.category,item) &&(
      <div className="config-section-wrapper">
        <h2 className="config-section-title">{item.name}</h2>
     </div>
     )
    }

     {item.type==='text' && checkCatergory(item.category,item) &&

          <div className='input-div' key={item}>
            <label className="floating-label" htmlFor="client-name-input">{item.displayname}</label>
            <Form.Item name={item.name} initialValue={(node.data)?node.data[item.name]:''} rules={[{ required: true }]}>
              <Input
                id="client-name-input"
                className='input-field-1'
                required type="text" 
                bordered={false}     
  
              />
                </Form.Item>
            </div>
       
    }
     {item.type==='radio' && checkCatergory(item.category,item)  &&

            <div className='' key={item}>
              <label className="floating-label font-sm" htmlFor="client-name-input">{item.displayname}</label>
              <Form.Item name={item.name} initialValue={(node.data)?node.data[item.name]:''} rules={[{ required: true }]}>
              <Radio.Group >
              {item.data.map((item:any) => {
                return <>
                <Radio className='radio-css' onChange={(e)=>{handleMultiOptionSelection(item,e)}} value={item.value}>{item.label}</Radio>
                </>
                  })
                }
                </Radio.Group>
                        
              </Form.Item>
            </div>
           
    }
     {item.type==='dropdown'&& checkCatergory(item.category,item) &&  
     
     <div className='input-div' key={item}>
            <InputLabel id="demo-simple-select-helper-label" className='floating-label'>{item.displayname}</InputLabel>
             <Form.Item name={item.name} initialValue={(node.data)?node.data[item.name]:''} rules={[{ required: true }]}>
                <Select
                  suffixIcon={<CaretDownOutlined style={{ fontSize: '16px',pointerEvents: 'none'  }} rev={undefined} />}
                   id="demo-simple-select-helper"
                    placeholder="Select an option"
                    className='input-field-1'
                    bordered={false}
                    options={item.data}
                    onChange={(e)=>{handleMultiOptionSelection(item,e)}}
                />
             </Form.Item>
       </div>

    }
        {/* <Form.Item name="phone" label="Phone" rules={[{ required: true }]}>
          <Input />
        </Form.Item>
        <Form.Item name="desc" label="Description" rules={[{ required: true }]}>
          <TextArea
            placeholder="Enter Description"
            autoSize={{ minRows: 3, maxRows: 6 }}
          />
        </Form.Item>
        <Form.Item name="radio" label="Radio" rules={[{ required: true }]}>
        <Radio.Group>
            <Radio value={1}>A</Radio>
            <Radio value={2}>B</Radio>
            <Radio value={3}>C</Radio>
            <Radio value={4}>D</Radio>
          </Radio.Group>
        </Form.Item>
        <Form.Item name="dropdown" label="Dropdown" rules={[{ required: true }]}>
        <Select
          placeholder="Select an option"
            options={[
              {
                value: 'jack',
                label: 'Jack',
              },
              {
                value: 'lucy',
                label: 'Lucy',
              },
              {
                value: 'disabled',
                label: 'Disabled',
              },
              {
                value: 'Yiminghe',
                label: 'yiminghe',
              },
            ]}
          />
        </Form.Item>
        <Form.Item name="checkboxgrp" label="Check boxes" rules={[{ required: true }]}>
          <Checkbox.Group >
                <Checkbox value="A">A</Checkbox>
                <Checkbox value="B">B</Checkbox>
          </Checkbox.Group>
        </Form.Item> */}
      {item.type==='button'&& checkCatergory(item.category,item) &&  
        <button
              className="rounded-primary-40 btn font--btn export-flow-btn config-save-btn w-full"
              type="button"
              onClick={(e)=>handleShowConditionForm()}
            >
            <div>{item.displayname}</div>
        </button>
       }   
    </>;
      }) }
      {/* <Form.Item >
        <Button type="primary" onClick={(e)=>handleShowConditionForm}>Test</Button>
      </Form.Item> */}
    

    </Form>
      <div className='config-footer'>
        <div className='config-controlBtns'>
            <button
                  className="rounded-primary-40 btn font--btn export-flow-btn config-cancel-btn"
                  type="button"
                  onClick={cancel}
                >
                <div>Cancel</div>
                </button>
            <button
                  className="rounded-primary-40 btn font--btn export-flow-btn config-save-btn"
                  type="button"
                  onClick={handleSubmit}
                >
                <div>Save</div>
                </button>
          </div>
      </div>
    </div>


  {/* <ConditionForm 

  
  /> */}
 </>
  );
};

export default ConfigForm;